import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "@/config/antd";
import AttendeesTab from "@/pages/event_management/single_campaign/components/attendees_tabs/Attendees_Tab";
import ManifestoTab from "@/pages/event_management/single_campaign/components/attendees_tabs/Manifesto_Tab";
import "@/assets/styles/custom_tabs.css";
import {
  fetchSingleManifesto,
  selectCurrentManifesto,
  selectManifestoLoading,
} from "@/store/redux/slices/manifesto/manifesto_slice";
import { selectCurrentEvent } from "@/store/redux/slices/event/event_slice";

const AttendeesSection = () => {
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const currentEvent = useSelector(selectCurrentEvent);
  const manifesto = useSelector(selectCurrentManifesto);
  const isLoading = useSelector(selectManifestoLoading);

  useEffect(() => {
    if (currentEvent?.manifestoID) {
      dispatch(
        fetchSingleManifesto({
          key: "_id",
          value: currentEvent.manifestoID,
        })
      );
    }
  }, [dispatch, currentEvent?.manifestoID]);

  const items = [
    {
      label: "Attendees",
      key: "1",
      children: <AttendeesTab />,
    },
    {
      label: "Manifesto",
      key: "2",
      children: <ManifestoTab manifesto={manifesto} isLoading={isLoading} />,
    },
  ];

  return (
    <div className="mt-8">
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        className="custom-tabs"
        tabBarStyle={{
          marginBottom: "24px",
        }}
      />
    </div>
  );
};

export default AttendeesSection;
